import { render, staticRenderFns } from "./card_user_count.vue?vue&type=template&id=23db09a2&scoped=true"
import script from "./card_user_count.vue?vue&type=script&lang=js"
export * from "./card_user_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db09a2",
  null
  
)

export default component.exports